module.exports = __webpack_public_path__ + "static/media/dragon-palace.9510d22a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/GameIcon/dragon-palace.png
// module id = 1368
// module chunks = 1